import React from 'react';

export function SectionLabel({ num, children, className = '', 'data-testid': testId }) {
  return (
    <div
      data-testid={testId}
      className={`flex items-center gap-4 text-xs uppercase tracking-[0.2em] text-ink-muted ${className}`}
    >
      <span className="text-ink-text/70 tabular-nums">{num}</span>
      <span aria-hidden className="h-px w-12 bg-white/15" />
      <span>{children}</span>
    </div>
  );
}
